import type { ContactApprovalState, Email } from '@/types/email';
import { formatShortDateTime } from '@/lib/dateDisplay';

export function getInitials(name?: string, email?: string) {
  if (name) {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
  if (email) {
    return email.slice(0, 2).toUpperCase();
  }
  return 'UN';
}

export function formatDate(date: Date | string) {
  return formatShortDateTime(date);
}

export function formatAddressDisplay(address: Email['from']): string {
  if (!address) {
    return '';
  }
  const name = address.name?.trim();
  if (name && name.length > 0 && name.toLowerCase() !== address.email.toLowerCase()) {
    return `${name} <${address.email}>`;
  }
  return address.email;
}

export function formatAddressList(addresses: Email['to']): string {
  if (!addresses || addresses.length === 0) {
    return '';
  }
  return addresses
    .map((entry) => formatAddressDisplay(entry))
    .filter(Boolean)
    .join(', ');
}

export function resolveContactApprovalState(
  current: ContactApprovalState | null | undefined,
  next: ContactApprovalState | null | undefined,
): ContactApprovalState | null {
  if (!next) {
    return current ?? null;
  }
  if (next === 'blocked') {
    return 'blocked';
  }
  if (next === 'pending') {
    return current === 'blocked' ? 'blocked' : 'pending';
  }
  return current ?? next ?? null;
}
